import { render } from "./MailboxLog.vue?vue&type=template&id=5042c230&scoped=true"
import script from "./MailboxLog.vue?vue&type=script&lang=js"
export * from "./MailboxLog.vue?vue&type=script&lang=js"

import "./MailboxLog.vue?vue&type=style&index=0&id=5042c230&lang=scss&scoped=true"

import exportComponent from "/build/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5042c230"]])

export default __exports__